// extracted by mini-css-extract-plugin
module.exports = {"disabled":"style__disabled__AFkF6"};